import { MagnifyingGlass } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

const NoReviewsFound = () => {
  const { t } = useTranslation(['organisation'])
  return (
    <div className="reputation-management-reminder__container">
      <div className="reputation-management-reminder__content">
        <MagnifyingGlass size={24} className="reputation-management-reminder__icon" />
        <div className="reputation-management-reminder__title">
          {t('organisation:reputationManagement.noReviewsFound.title')}
        </div>
        <div className="reputation-management-reminder__subtitle">
          {t('organisation:reputationManagement.noReviewsFound.subtitle')}
        </div>
      </div>
    </div>
  )
}

export default NoReviewsFound
